module.exports = __webpack_public_path__ + "img/ir.9219b4a5.svg";